// javascript
import React, { useEffect, useState, useRef, useContext } from 'react';
import api from '../../helper/util/api';
import PersonAutocomplete from '../../helper/input/PersonAutocomplete';
import DocketRow from './components/DocketRow';
import MeetingRow from './components/MeetingRow';
import TncAlert from './components/TncAlert';
import CommsStatus from './components/CommsStatus';
import InputError from '../../helper/input/InputError';
import StateDropDown from '../../helper/input/StateDropDown';
import Autocomplete from '../../helper/input/Autocomplete';
import CountryCodeSelect from '../../helper/input/CountryCodeSelect';
import { AuthContext } from "../../helper/util/AuthContext";

export default function LeadManagement() {
  const [clients, setClients] = useState([]);
  const [leadId, setLeadId] = useState('');
  const [deal, setDeal] = useState(null);
  const [activeTab, setActiveTab] = useState('personal');
  const [personInfo, setPersonInfo] = useState({
    name:'',
    email:'',
    dial_code:'91',
    mobile:'',
    dob:'',
    mailing_address:''
  });

  const [requirements, setRequirements] = useState({
    state: '',
    location: '',
    deal_type: '',
    property_classification: '',
    property_type: '',
    property_sub_type: '',
    required_area: '',
    purpose: ''
  });

  // POC states (desk number, extension, mobile)
  const [poc, setPoc] = useState(null);
  // Agent states
  const [agent, setAgent] = useState(null);

  const [dockets, setDockets] = useState([]);
  const [newDocketRows, setNewDocketRows] = useState([]);

  const [meetings, setMeetings] = useState([]);
  const [newMeetingRows, setNewMeetingRows] = useState([]);

  const [closure, setClosure] = useState(false);
  const [commsStatus, setCommsStatus] = useState([]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const debounceRef = useRef(null);
  const { user } = useContext(AuthContext);

  useEffect(() => { loadClients(); }, []);

  const getDialCode = () => {
    return typeof personInfo?.dial_code === 'object' ? personInfo?.dial_code?.dialCode : personInfo?.dial_code;
  }

  async function loadClients() {
    try {
      const res = await api.get('/leads-active');
      setClients(res.data);
    } catch (err) { console.error(err); }
  }

  async function loadCommsStatus() {
    if (!leadId) return;
    try {
      const res = await api.get(`/deals/${leadId}/commsStatus`);
      setCommsStatus(res.data || []);
    } catch (err) {
      console.error(err);
      alert('Failed to load Communication Status');
    }
  }

  async function handleGetData() {
    if (!leadId) return alert('Choose client');
    setLoading(true);
    setErrors({});
    try {
      const personRes = await api.get(`/deals/${leadId}/persons`);
      setPersonInfo({...personRes.data.client, dob: personRes.data.client?.dob?.split("T")[0]} || {});
      setPoc(personRes.data.poc || {}); 
      //setAgent(null); 
      const dealRes = await api.get(`/deals/${leadId}/requirement`);
      setRequirements(dealRes.data || {})

      const deal = await api.get(`/deals/${leadId}`);
      setDeal(deal.data);
      window.__CURRENT_DEAL_ID__ = leadId;
      setClosure(!!dealRes.data.closure);

      const dRes = await api.get(`/deals/${leadId}/dockets`);
      setDockets(dRes.data || []);
      const mRes = await api.get(`/deals/${leadId}/meetings`);
      setMeetings(mRes.data || []);

      setNewDocketRows([]); setNewMeetingRows([]);
      await loadCommsStatus();
      setLoading(false);
    } catch (err) { console.error(err); alert('Failed to fetch data'); setLoading(false); }
  }

  const clearExistingData = () => {
    setErrors({});
    setDeal(null)
    setLeadId('');
    setPersonInfo({
      name:'',
      email:'',
      dial_code:'91',
      mobile:'',
      dob:'',
      mailing_address:''
    });
    setRequirements({
      state: '',
      location: '',
      deal_type: '',
      property_classification: '',
      property_type: '',
      property_sub_type: '',
      required_area: '',
      purpose: ''
    });
    setPoc(null);
    setAgent(null);

    setDockets([]);
    setNewDocketRows([]);

    setMeetings([]);
    setNewMeetingRows([]);

    setClosure(false);
    setCommsStatus([]);
    setActiveTab('personal');
  }

  //Ser error Message
  const setErrorMsg = (field, value) => {
    setErrors(prev => ({ ...prev, [field]: value }));
  }

  //Start : Validate Inputs
  const emailRegex = /^(?!.*\.\.)([A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+)@([A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*)\.([A-Za-z]{2,})$/;
  const mobileRegex = /^[6-9]\d{9}$/
  const validateInputs = (field, value) => {
    if (!value && field !== 'email') {
      setErrorMsg(field, `Please enter value`)
      return;
    } else {
      setErrorMsg(field, null)
    }
    
    if(value && field === 'email'){
        if(!emailRegex.test(value)){
          setErrorMsg(field, "Please enter valid email")
        } else {
          checkUnique(field, value)
        }
    }
    if(field === 'mobile'){
      if(!mobileRegex.test(value)){
        setErrorMsg(field, "Please enter valid mobile number")
      } else {
        checkUnique(field, value)
      }
    }
  }
  //End : Validate Inputs

  //Start : Check unique email and contact no
  const checkUnique = async (field, value) => {
    if (!value || leadId) return;
    try {
      const q = new URLSearchParams({ [field]: value }).toString();
      const res = await api.get(`/users/check?${q}`);
      const data = res.data;
      if (field === 'email') {
        //setErrors(prev => ({ ...prev, email: data.emailUnique ? null : 'Email already in use' }));
        setErrorMsg(field, data.emailUnique ? null : 'Email already in use')
      } else if (field === 'mobile') {
        //setErrors(prev => ({ ...prev, phone: data.mobileUnique ? null : 'Phone already in use' }));
        setErrorMsg(field, data.mobileUnique ? null : 'Phone already in use')
      }
    } catch (err) {
      console.error('Check unique error', err);
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    console.log("onBlur field: ", name, " value: ", value);
    // debounce to avoid too many requests
    validateInputs(name, value);
  };
  //End : Check unique email and contact no

  //Check Errors
  const checkDataValidity = (formType) => {
    let valid = true;
    if(formType === 'personal'){
      if(!personInfo.name || !personInfo.mobile){
        valid = false;
        alert('Please fill all required personal details');
      }
      if(personInfo.mobile && errors.mobile){
        valid = false;
        alert('Please correct mobile number');
      }
      if(personInfo.email && errors.email){
        valid = false;
        alert('Please correct email address');
      }
      if(!requirements.state && !requirements.location && !requirements.deal_type && 
        !requirements.property_classification && !requirements.property_type && 
        !requirements.property_sub_type && !requirements.required_area){
        valid = false;
        alert('Please fill the requirements details');
      }
      if(poc === null){
        valid = false;
        alert('Please select a POC');
      }
    }
    return valid;
  }

  //save personal info, Requirements, POC and owner.
  async function SaveIRPC() {
    const data = {
      c_details: {...personInfo, dial_code: getDialCode()},
      c_req: requirements,
      poc: poc,
    }

    if (checkDataValidity('personal')) {
      setLoading(true)
      try {
        const res = await api.post('/SaveIRPC', data);
        setLeadId(res?.data?.lead?.id);
        setDeal(res?.data?.lead);
        setClients([...clients, res?.data?.activeLead]);
        window.__CURRENT_DEAL_ID__ = res?.data?.lead?.id;
        alert('Requirements saved');
        setLoading(false)
      } catch (err) {
        console.error(err);
        alert(err.response.data.message || 'Failed to save requirements');
        setLoading(false)
      }
    }
  }

  async function UpdateIRPC() {
    if (deal) {
      const data = {
        leadId: leadId,
        c_req: requirements,
      }
      setLoading(true);
      try {
        const res = await api.post('/UpdateIRPC', data);
        alert('Requirements saved');
        setLoading(false);
      } catch (err) { 
        console.error(err); 
        alert('Failed to update requirements'); 
        setLoading(false);
      }
    }
  }

  async function DeleteLead() {
    if (!leadId) return alert('No lead selected');
    if (!window.confirm('Are you sure you want to delete this lead?')) return;
    try {
      const res = await api.post(`/deals/${leadId}/delete`);
      alert('Lead deleted');
      clearExistingData();
      setClients(clients.filter(c => c.id !== leadId));
    } catch (err) { 
      console.error(err); 
      alert('Failed to delete lead'); 
    }
  }

  function handleAddDocketRow() { setNewDocketRows(prev => [...prev, { uid: Date.now() }]); }
  function handleCancelDocketRow(uid) { setNewDocketRows(prev => prev.filter(r => r.uid !== uid)); }
  function handleDocketUploaded(newDocket) {
    setDockets(prev => [newDocket, ...prev]);
    setNewDocketRows(prev => prev.slice(1));
  }

  function handleAddMeetingRow() { setNewMeetingRows(prev => [...prev, { uid: Date.now() }]); }
  function handleCancelMeetingRow(uid) { setNewMeetingRows(prev => prev.filter(r => r.uid !== uid)); }
  function handleMeetingSaved(newMeeting, actionType) {
    if(actionType === 'add'){
      setMeetings(prev => [newMeeting, ...prev]);
      setNewMeetingRows(prev => prev.slice(1));
    }
    else if(actionType === 'update'){
      let updatedRows = meetings.map(mData=> {
        if(mData.id === newMeeting.id){
          return newMeeting;
        }
        return mData;
      });
      setMeetings(updatedRows);
    }
  }

  async function toggleClosure() {
    if (!deal) return alert('No deal found');
    try {
      const res = await api.post(`/deals/${deal.id}/closure`, { closure: !closure });
      setClosure(!!res.data.closure);
      setDeal(res.data);
      alert('Closure updated');
    } catch (err) { console.error(err); alert('Failed'); }
  }

  // When person selected, auto-fill mobile (editable). Desk/ext left for manual input.
  function handleClientChange(val) {
    setPersonInfo({ name: val, dial_code:'91' });
  }
  function handleClientSelect(person) {
    if(person)
    setPersonInfo({...person, dob: person?.dob?.split("T")[0]} || {});
  }
  function handlePocSelect(person) {
    setPoc(person);
  }
  function handleAgentSelect(person) {
    setAgent(person);
  }

  function onTncSent(data) {
      setDeal(data);
  }
  
  return (
    <div className="page-container">
      {
        deal?.tnc_agreed === 0 && (
          <TncAlert onTncSent={onTncSent} />
        )
      }
      <div className="header">
        <h2>Lead Management</h2>
        <div className="controls">
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <label className="meta">Client</label>
            <select value={leadId} onChange={e => setLeadId(e.target.value)}>
              <option value="">Select client</option>
              {clients.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
            <button onClick={handleGetData}>{loading ? 'Loading...' : 'Load Data'}</button>
            <button onClick={clearExistingData}>Add New Data</button>
          </div>
        </div>
      </div>

      <div className="tabs" role="tablist">
        <div className={`tab ${activeTab === 'personal' ? 'active' : ''}`} onClick={() => setActiveTab('personal')}>Personal</div>
        <div className={`tab ${activeTab === 'docket' ? 'active' : ''}`} onClick={() => setActiveTab('docket')}>Upload Docket</div>
        <div className={`tab ${activeTab === 'meeting' ? 'active' : ''}`} onClick={() => setActiveTab('meeting')}>Schedule Meeting</div>
        <div className={`tab ${activeTab === 'post' ? 'active' : ''}`} onClick={() => setActiveTab('post')}>Post Closure</div>
        <div className={`tab ${activeTab === 'comms-status' ? 'active' : ''}`} onClick={() => setActiveTab('comms-status')}>Message Status</div>
        {
          (leadId && user?.role === 'admin') && (
            <button className={`delete-tab`} onClick={DeleteLead} >
              <img src="/assets/delete-icon.svg" alt="delete lead" style={{ width: 25, height: 25, marginTop: 4 }} />
            </button>
          )
        }
      </div>
      {activeTab === 'personal' && (
        <div className="panel">
          <div className="section-title"><h3>Personal Information</h3></div>

          <div className="form-row two-col-row">
            <div>
              {/* <label className="label">Full Name</label>
              <input className="input" type="text" name="name" placeholder="Full name" value={personInfo.name || ''} onChange={e => setPersonInfo({ ...personInfo, name: e.target.value })} onBlur={handleBlur} /> */}
              <PersonAutocomplete personType="client" name="name" person_data={personInfo} onSelect={handleClientSelect} onChange={handleClientChange} onBlur={handleBlur} label="Full Name" placeholder="Enter Full Name" showContact={false} disabled={!!deal?.id} />
              <InputError errMsg={errors.name} /> 
            </div>
            <div>
              <label className="label">Email</label>
              <input className="input" type="text" name="email" placeholder="you@example.com" value={personInfo?.email || ''} onChange={e => setPersonInfo({ ...personInfo, email: e.target.value })} onBlur={handleBlur} disabled={!!deal?.id} />
              <InputError errMsg={errors.email} />
            </div>
          </div>

          <div className="form-row two-col-row">
            <div>
              <label className="label">Contact (Whatsapp)</label>
              <div className='display-f'>
                <CountryCodeSelect value={personInfo?.dial_code} onChange={(value) => setPersonInfo({ ...personInfo, dial_code: value })} />
                <input className="input" type="tel" name="mobile" pattern="[0-9]{10}" placeholder="XXXXXXXXXX" value={personInfo?.mobile || ''} onChange={e => setPersonInfo({ ...personInfo, mobile: e.target.value })} onBlur={handleBlur} disabled={!!deal?.id} />
              </div>
              <InputError errMsg={errors.mobile} />
            </div>

            <div>
              <label className="label">DOB</label>
              <input className="input" type="date" name="dob" value={personInfo?.dob || ''} onChange={e => setPersonInfo({ ...personInfo, dob: e.target.value })} disabled={!!deal?.id}/>
            </div>
          </div>

          <div className="form-row">
            <label className="label">Billing Address</label>
            <textarea className="col-full" rows="3" value={personInfo?.mailing_address || ''} onChange={e => setPersonInfo({ ...personInfo, mailing_address: e.target.value })} disabled={!!deal?.id}/>
          </div>

          <div style={{ height: 12 }} />

          <div className="section-title"><h3>Requirements</h3></div>

          <div className="form-row two-col-row">
            <div>
              <label className="label">State</label>
              <StateDropDown value={requirements?.state} onChange={(value) => setRequirements({ ...requirements, state: value })} />
            </div>

            <div>
              <label className="label">Location</label>
              <input className="input" type="text" placeholder="City / Area" value={requirements?.location} onChange={e => setRequirements({ ...requirements, location: e.target.value })} />
            </div>
          </div>

          <div className="form-row two-col-row">
            <div>
              <label className="label">Deal Type</label>
              <select className="input" name="deal_type" value={requirements?.deal_type} onChange={e => setRequirements({ ...requirements, deal_type: e.target.value })}>
                <option value="">-- Select --</option>
                <option value="SALE">SALE</option>
                <option value="INVESTMENT-PRE_LEASE">INVESTMENT - PRE LEASE</option>
                <option value="SALE/LEASE">SALE / LEASE</option>
                <option value="JV">JV</option>
                <option value="LEASE">LEASE</option>
              </select>
            </div>

            <div>
              <label className="label">Property Classification</label>
              <select className="input" name="property_classification" value={requirements?.property_classification} onChange={e => setRequirements({ ...requirements, property_classification: e.target.value })}>
                <option value="">-- Select --</option>
                <option value="Industrial">INDUSTRIAL</option>
                <option value="Industrial/Commercial">INDUSTRIAL / COMMERCIAL</option>
                <option value="Commercial">COMMERCIAL</option>
              </select>
            </div>
          </div>

          <div className="form-row two-col-row">
            <div>
              <label className="label">Property Type</label>
              <select className="input" name="property_classification" value={requirements?.property_type} onChange={e => setRequirements({ ...requirements, property_type: e.target.value })}>
                <option value="">-- Select Type --</option>
                <option value="OPEN PLOT">OPEN PLOT</option>
                <option value="OFFICE SPACE">OFFICE SPACE</option>
                <option value="RETAIL SHOP">RETAIL SHOP</option>
                <option value="BUILD UP">BUILD UP</option>
                <option value="ANY">ANY</option>
              </select>
            </div>

            <div>
              <label className="label">Property Sub Type</label>
              <select className="input" value={requirements?.property_sub_type} onChange={e => setRequirements({ ...requirements, property_sub_type: e.target.value })}>
                <option value="">-- Select Sub type --</option>
                <option value="Fenced">FENCED</option>
                <option value="Non-Fenced">NON-FENCED</option>
                <option value="Furnished">FURNISHED</option>
                <option value="Non-Furnished">NON-FURNISHED</option>
                <option value="RCC">RCC</option>
                <option value="Shed_WOC">SHED WOC</option>
                <option value="Shed_WC">SHED WC</option>
                <option value="Warehouse">WAREHOUSE</option>
                <option value="Cold Storage">COLD STORAGE</option>
                <option value="Any">ANY</option>
              </select>
            </div>
          </div>

          <div className='form-row two-col-row'>
            <div>
              <label className="label">Required Area</label>
              <input className="input" type="text" placeholder="e.g., 1000 sqft" value={requirements?.required_area} onChange={e => setRequirements({ ...requirements, required_area: e.target.value })} />
            </div>
            <div>
              <label className="label">Purpose / Activity</label>
              <input className="input" type="text" placeholder="e.g., Investment" value={requirements?.purpose || ''} onChange={e => setRequirements({ ...requirements, purpose: e.target.value })} />
            </div>
          </div>

          {/* <div style={{ height: 8 }} />
          <div className="section-title"><h3>External Agent</h3></div>
          
          <div className="form-row two-col-row">
            <div>
              <PersonAutocomplete personType="agent" valueId={agent?.id} onSelect={handleAgentSelect} label="Agent" />
            </div>
          </div> */}
          
          <div style={{ height: 8 }} />
          <div className="form-row two-col-row">
            <div>
              <div className="section-title"><h3>Point of Contact</h3></div>
              <PersonAutocomplete personType="executive,manager,admin" person_data={poc} onSelect={handlePocSelect} label="POC (executive)" placeholder="Search POC" disabled={!!deal?.id} />
            </div>
          </div>

          <div style={{ marginTop: "14px", display: "flex",gap: "8px",justifyContent: "center" }} className="responsive-row">
            {deal ? (
            <button onClick={UpdateIRPC} style={{padding: "10px 35px"}}>{loading ? 'Updateing...' : 'Update Requirements'}</button>
            ) : (
              <button onClick={SaveIRPC} style={{padding: "10px 35px"}}>{loading ? 'Saving...' : 'Save'}</button>
            ) }
            
          </div>
        </div>
      )}

      {/* Docket, Meeting, Post tabs unchanged - omitted here for brevity */}
      {activeTab === 'docket' && (
        <div className="panel">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="section-title"><h3>Dockets</h3></div>
            <div>
              <button onClick={handleAddDocketRow} className="btn-small">Add New Docket</button>
            </div>
          </div>
          <div style={{ marginTop: 10 }}>
            <div className="list" style={{ marginBottom: 12 }}>
              {newDocketRows.map(r => (
                <div key={r.uid} className="list-item" style={{ flexDirection: 'column', alignItems: 'stretch' }}>
                  <DocketRow data={null} onUploaded={(d) => handleDocketUploaded(d)} onCancel={() => handleCancelDocketRow(r.uid)} />
                </div>
              ))}
            </div>
            <div className="section-title">Existing Dockets</div>
            <div className="list" style={{ marginTop: 8 }}>
              {dockets.length === 0 && <div className="small-muted">No dockets yet</div>}
              {dockets.map(data => <DocketRow key={data.id} data={data} />)}
            </div>
          </div>
        </div>
      )}

      {activeTab === 'meeting' && (
        <div className="panel">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="section-title"><h3>Meetings</h3></div>
            <div>
              <button onClick={handleAddMeetingRow} className="btn-small">Add New Meeting</button>
            </div>
          </div>
          <div style={{ marginTop: 10 }}>
            <div className="list" style={{ marginBottom: 12 }}>
              {newMeetingRows.map(r => (
                <div key={r.uid} className="list-item" style={{ flexDirection: 'column', alignItems: 'stretch' }}>
                  <MeetingRow data={null} onSaved={handleMeetingSaved} onCancel={() => handleCancelMeetingRow(r.uid)} />
                </div>
              ))}
            </div>
            <div className="section-title">Existing Meetings</div>
            <div className="list" style={{ marginTop: 8 }}>
              {meetings.length === 0 && <div className="small-muted">No meetings scheduled</div>}
              {meetings.map(m => <MeetingRow key={m.id} data={m} onSaved={handleMeetingSaved} />)}
            </div>
          </div>
        </div>
      )}

      {activeTab === 'post' && (
        <div className="panel">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div className="section-title"><h3>Post Closure</h3></div>
              <div style={{ marginTop: 8 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input type="checkbox" checked={closure} onChange={toggleClosure} disabled={deal?.closure !== 1 || deal?.status === 'success'} />
                  <span className="meta">Deal Closed</span>
                </label>
              </div>
            </div>
          </div>
          <div style={{ marginTop: 16 }}>
            <div className="section-title">Milestones</div>
            <div style={{ display: 'grid', gap: 8, gridTemplateColumns: 'repeat(auto-fit, minmax(160px,1fr))' }}>
              <div className="list-item">Requirements Accepted: <strong>{deal?.req_received  ? 'Yes' : 'No'}</strong></div>
              <div className="list-item">Docket Uploaded: <strong>{deal?.docket_uploaded ? 'Yes' : 'No'}</strong></div>
              <div className="list-item">Meeting Scheduled: <strong>{deal?.visit_scheduled ? 'Yes' : 'No'}</strong></div>
              <div className="list-item">Pre Closure: <strong>{deal?.preclosure ? 'Yes' : 'No'}</strong></div>
              <div className="list-item">Closure: <strong>{deal?.closure ? 'Yes' : 'No'}</strong></div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'comms-status' && (
        <div className="panel">
          <CommsStatus leadId={leadId} data={commsStatus} getData={loadCommsStatus} />
        </div>
      )}
    </div>
  );
}
